import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import AppRouter from './Componentes/AppRouter/AppRouter'

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
